<template>

    <div class="h-100 m-0">
        <HeaderNav/>
        <div class="sidenav">

            <b-button-group vertical class="m-1 p-1">
                <b-button id="button-orglist" variant="outline-dark" squared size="lg" :to="{ name: 'OrganizationList' }">
                    <font-awesome-icon icon="layer-group" />
                </b-button>
                <b-button id="button-dashboard" v-if="isOrganizationValid" variant="outline-dark" squared size="lg" :to="{ name: 'Dashboard',  params: {orgId: organizationId} }">
                    <font-awesome-icon icon="th" />
                </b-button>
                <b-button id="button-organization" v-if="isOrganizationValid" variant="outline-dark" squared size="lg" :to="{ name: 'Organization', params: {orgId: organizationId} }">
                    <font-awesome-icon icon="users" />
                </b-button>
                <b-button id="button-athletes" v-if="isOrganizationValid" variant="outline-dark" squared size="lg" :to="{ name: 'AthleteList', params: {orgId: organizationId} }">
                    <font-awesome-icon icon="running" />
                </b-button>
                <b-button id="button-sessions" v-if="isOrganizationValid" variant="outline-dark" squared size="lg" :to="{ name: 'DefaultSessionList', params: {orgId: organizationId} }">
                    <font-awesome-icon icon="chart-bar" />
                </b-button>
            </b-button-group>

            <b-tooltip target="button-orglist" triggers="hover" placement="right">
              Organizations
            </b-tooltip>

            <b-tooltip target="button-dashboard" v-if="isOrganizationValid" triggers="hover" placement="right">
              Dashboard
            </b-tooltip>

            <b-tooltip target="button-organization" v-if="isOrganizationValid" triggers="hover" placement="right">
               Organization Users
            </b-tooltip>
            <b-tooltip target="button-athletes" v-if="isOrganizationValid" triggers="hover" placement="right">
                Athletes
            </b-tooltip>
            <b-tooltip target="button-sessions" v-if="isOrganizationValid" triggers="hover" placement="right">
                Sessions
            </b-tooltip>

          <div class="m-2" style=" font-size: x-small; color: #bbbbbb; position: absolute; bottom: 0px;">
            v{{getWebAppVersion}}
            api@v{{serverVersion}}
          </div>

        </div>
        <div id="main" >
            <router-view></router-view>
        </div>

    </div>
</template>

<script>

    import HeaderNav from '../HeaderNav.vue'
    import { mapGetters } from 'vuex'
    import { version } from "../../../package.json";

    export default {
        name: "RootPage",
        components: {
            HeaderNav,
        },
        computed: {
            ...mapGetters({
                organizationId: 'organization/currentId',
                organizationName: 'organization/currentName',
                organizationLoading: 'organization/currentLoadingOrNull',
                organizationLoadingError: 'organization/currentLoadingError',

                serverVersion: 'server/serverVersion'

            }),

            isOrganizationValid: function() {
                return !(this.organizationLoading || this.organizationLoadingError)
            },

            getWebAppVersion: function() {
              return version
            }
        }
    }
</script>

<style scoped>

    .sidenav {
        height: 100%; /* 100% Full-height */
        /*width: 60px; /* 0 width - change this with JavaScript */
        position: fixed; /* Stay in place */
        top: 0; /* Stay at the top */
        left: 0;
        background-color: #e9ecef;
        padding-top: 65px; /* Place content 60px from the top */
    }

    #main {
        margin-left: 60px;
    }

</style>